<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="none" name="plantCd" v-model="searchParam.plantCd" @input="changePlant" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="REGULATION_BILL_CD"
            itemText="codeName"
            itemValue="code"
            type="search"
            label="관련 법규"
            name="searchLaw"
            @input="billCdChange"
            v-model="searchParam.searchLaw">
          </c-select>
        </div> -->
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            :comboItems="regulatedItems"
            itemText="regulatedItemName"
            itemValue="regulatedItemCd"
            label="규제 사항"
            name="regulatedItemCd"
            v-model="searchParam.regulatedItemCd">
          </c-select>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="searchTypeItems"
            type="none"
            itemText="codeName"
            itemValue="code"
            name="searchTypeItem"
            label="계획서 구분"
            @input="searchTypeItemChange"
            v-model="searchParam.searchTypeItem"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" v-show="revisioinItems.length > 0">
          <c-select
            type="custom"
            typetxt="현재 목록"
            :comboItems="revisioinItems"
            itemText="revisionName"
            itemValue="sysRevision"
            label="계획서 구분별 개정목록"
            name="sysRevision"
            @input="revisionChange"
            v-model="searchParam.sysRevision">
          </c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="grid"
          title="유해위험물질 목록"
          tableId="grid"
          :columns="grid.columns"
          :data="grid.data"
          :merge="grid.merge"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="현재목록 저장" icon="save" @btnClicked="openRevision" v-if="editable && saveable && grid.data.length > 0" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props }">
            <template v-if="props.row['regulatedItemName']">
              <span style="color: #fb8c00">
                {{props.row['regulatedItemName'].replace(/,/g, ' / ')}}
              </span>
            </template>
            <template v-else>
            </template>
          </template>
        </c-table>
        <c-dialog :param="popupOptions"></c-dialog>
      </div>
    </div>
    <q-dialog v-model="prompt" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">유해화학물질 목록 개정</div>
        </q-card-section>

        <q-card-section class="q-pt-none" style="padding-top:20px">
          <c-text
            :required="true"
            label="개정번호"
            :editable="false"
            name="revisionNum"
            v-model="revisionInfo.revisionNum">
          </c-text>
          <c-datepicker
            :required="true"
            label="개정일자"
            name="revisionDt"
            v-model="revisionInfo.revisionDt"
          />
          <c-text
            label="개정사유"
            name="revisionContent"
            v-model="revisionInfo.revisionContent">
          </c-text>
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="취소" @click="cancelRevision" />
          <q-btn flat label="개정" @click="saveRevision" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'hsl-manage',
  data() {
    return {
      prompt: false,
      searchParam: {
        plantCd: null,
        regulatedItemCd: null,
        searchLaw: null,
        sysRevision: null,
        searchTypeItem: '1',
      },
      revisionInfo: {
        plantCd: null,
        sysRevision: '',
        revisionNum: '',
        revisionDt: '',
        revisionContent: '',
        regUserId: '',
      },
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      searchTypeItems: [
        { code: '1', codeName: '유해ㆍ위험방지계획서' },
        // { code: '2', codeName: '화학사고예방관리계획서' },
      ],
      regulatedItems: [],
      revisioinItems: [],
      saveable: true,
      columns1: {
        merge: [
          { index: 0, colName: 'mdmChemMaterialId' },
          { index: 1, colName: 'mdmChemMaterialId' },
          { index: 6, colName: 'mdmChemMaterialId' },
          { index: 7, colName: 'mdmChemMaterialId' },
          { index: 8, colName: 'mdmChemMaterialId' },
          { index: 9, colName: 'mdmChemMaterialId' },
          { index: 10, colName: 'mdmChemMaterialId' },
          { index: 11, colName: 'mdmChemMaterialId' },
          { index: 12, colName: 'mdmChemMaterialId' },
          { index: 13, colName: 'mdmChemMaterialId' },
          { index: 14, colName: 'mdmChemMaterialId' },
          { index: 15, colName: 'mdmChemMaterialId' },
          // { index: 16, colName: 'mdmChemMaterialId' },
          // { index: 17, colName: 'mdmChemMaterialId' },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:120px',
            sortable: false,
            fix: true,
          },
          // {
          //   name: 'materialName',
          //   field: 'materialName',
          //   label: '화학자재',
          //   align: 'left',
          //   style: 'width:200px',
          //   type: 'link',
          //   sortable: false,
          //   fix: true,
          // },
          {
            name: 'modelName',
            field: 'modelName',
            label: '모델명',
            align: 'left',
            style: 'width:200px',
            type: 'link',
            sortable: false,
            fix: true,
          },
          {
            name: 'chemNmKr',
            field: 'chemNmKr',
            label: '화학물질',
            align: 'left',
            style: 'width:200px',
            type: 'link',
            sortable: false,
            fix: true,
          },
          {
            name: 'casNo',
            field: 'casNo',
            label: 'CAS No.',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'molecularFormula',
            field: 'molecularFormula',
            label: '분자식',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제사항',
            align: 'center',
            style: 'width:200px',
            type: 'custom',
            sortable: false,
          },
          {
            label: '폭발한계(%)',
            align: 'center',
            child: [
              {
                name: 'explUpLimit',
                field: 'explUpLimit',
                label: '상한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
              {
                name: 'explLowLimit',
                field: 'explLowLimit',
                label: '하한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
            ]
          },
          {
            name: 'exposureLimit',
            field: 'exposureLimit',
            label: '노출기준',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'toxicValue',
            field: 'toxicValue',
            label: '독성치',
            align: 'center',
            style: 'width:300px',
            sortable: false,
          },
          {
            name: 'flashingPoint',
            field: 'flashingPoint',
            label: '인화점(℃)',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'ignitionPoint',
            field: 'ignitionPoint',
            label: '발화점(℃)',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'vaporPressure',
            field: 'vaporPressure',
            label: '증기압(20℃)',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'corrosivenessFlag',
            field: 'corrosivenessFlag',
            label: '부식성유무',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'extraReaction',
            field: 'extraReaction',
            label: '이상반응유무',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          // {
          //   name: 'dailyUsage',
          //   field: 'dailyUsage',
          //   label: '일일사용량',
          //   align: 'center',
          //   style: 'width:100px',
          //   type: 'cost',
          //   sortable: false,
          // },
          // {
          //   name: 'stockage',
          //   field: 'stockage',
          //   label: '저장량',
          //   align: 'center',
          //   style: 'width:100px',
          //   type: 'cost',
          //   sortable: false,
          // },
          {
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
        ],
      },
      columns2: {
        merge: [
          { index: 0, colName: 'revisionNum' },
          { index: 1, colName: 'revisionNum' },
          { index: 2, colName: 'revisionNum' },
          { index: 3, colName: 'revisionNum' },
          { index: 4, colName: 'mdmChemMaterialId' },
          { index: 8, colName: 'mdmChemMaterialId' },
          { index: 9, colName: 'mdmChemMaterialId' },
          { index: 10, colName: 'mdmChemMaterialId' },
          { index: 11, colName: 'mdmChemMaterialId' },
          { index: 12, colName: 'mdmChemMaterialId' },
          { index: 13, colName: 'mdmChemMaterialId' },
          { index: 14, colName: 'mdmChemMaterialId' },
          { index: 15, colName: 'mdmChemMaterialId' },
          { index: 16, colName: 'mdmChemMaterialId' },
          { index: 17, colName: 'mdmChemMaterialId' },
          { index: 18, colName: 'mdmChemMaterialId' },
          { index: 19, colName: 'mdmChemMaterialId' },
          { index: 20, colName: 'mdmChemMaterialId' },
        ],
        columns: [
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: '개정번호',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'revisionDt',
            field: 'revisionDt',
            label: '개정일자',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'revisionContent',
            field: 'revisionContent',
            label: '개정사유',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'materialName',
            field: 'materialName',
            label: '화학자재',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'chemNmKr',
            field: 'chemNmKr',
            label: '화학물질',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'casNo',
            field: 'casNo',
            label: 'CAS No.',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'molecularFormula',
            field: 'molecularFormula',
            label: '분자식',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제사항',
            align: 'center',
            style: 'width:200px',
            type: 'custom',
            sortable: false,
          },
          {
            label: '폭발한계(%)',
            align: 'center',
            child: [
              {
                name: 'explUpLimit',
                field: 'explUpLimit',
                label: '상한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
              {
                name: 'explLowLimit',
                field: 'explLowLimit',
                label: '하한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
            ]
          },
          {
            name: 'exposureLimit',
            field: 'exposureLimit',
            label: '노출기준',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'toxicValue',
            field: 'toxicValue',
            label: '독성치',
            align: 'center',
            style: 'width:300px',
            sortable: false,
          },
          {
            name: 'flashingPoint',
            field: 'flashingPoint',
            label: '인화점',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'ignitionPoint',
            field: 'ignitionPoint',
            label: '발화점',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'vaporPressure',
            field: 'vaporPressure',
            label: '증기압',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'corrosivenessFlag',
            field: 'corrosivenessFlag',
            label: '부식성유무',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'extraReaction',
            field: 'extraReaction',
            label: '이상반응유무',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'dailyUsage',
            field: 'dailyUsage',
            label: '일일취급량',
            align: 'center',
            style: 'width:100px',
            type: 'cost',
            sortable: false,
          },
          {
            name: 'stockage',
            field: 'stockage',
            label: '저장량',
            align: 'center',
            style: 'width:100px',
            type: 'cost',
            sortable: false,
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
        ],
      },
      columns3: {
        merge: [
          { index: 0, colName: 'mdmChemMaterialId' },
          { index: 1, colName: 'mdmChemMaterialId' },
          { index: 5, colName: 'mdmChemMaterialId' },
          { index: 6, colName: 'mdmChemMaterialId' },
          { index: 7, colName: 'mdmChemMaterialId' },
          { index: 8, colName: 'mdmChemMaterialId' },
          { index: 9, colName: 'mdmChemMaterialId' },
          { index: 10, colName: 'mdmChemMaterialId' },
          { index: 11, colName: 'mdmChemMaterialId' },
          { index: 12, colName: 'mdmChemMaterialId' },
          { index: 13, colName: 'mdmChemMaterialId' },
          { index: 14, colName: 'mdmChemMaterialId' },
          { index: 15, colName: 'mdmChemMaterialId' },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'materialName',
            field: 'materialName',
            label: '화학자재',
            align: 'left',
            style: 'width:200px',
            type: 'link',
            sortable: false,
          },
          {
            name: 'chemNmKr',
            field: 'chemNmKr',
            label: '유해화학물질명',
            align: 'left',
            style: 'width:200px',
            type: 'link',
            sortable: false,
          },
          {
            name: 'casNo',
            field: 'casNo',
            label: '화학물질식별번호',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제사항',
            align: 'center',
            style: 'width:200px',
            type: 'custom',
            sortable: false,
          },
          {
            name: 'serialNo',
            field: 'serialNo',
            label: '고유번호',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'propertiesStateName',
            field: 'propertiesStateName',
            label: '물질상태',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'concentration',
            field: 'concentration',
            label: '농도(%)',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'specificGravity',
            field: 'specificGravity',
            label: '비중',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            label: '폭발한계(%)',
            align: 'center',
            child: [
              {
                name: 'explUpLimit',
                field: 'explUpLimit',
                label: '상한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
              {
                name: 'explLowLimit',
                field: 'explLowLimit',
                label: '하한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
            ]
          },
          {
            name: 'toxicType',
            field: 'toxicType',
            label: '독성구분',
            align: 'center',
            style: 'width:300px',
            sortable: false,
          },
          {
            name: 'exposureLevel',
            field: 'exposureLevel',
            label: '위험노출수준',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'acceptableConcentration',
            field: 'acceptableConcentration',
            label: '허용농도값',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'vaporPressure',
            field: 'vaporPressure',
            label: '증기압(20℃)',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'corrosivenessFlag',
            field: 'corrosivenessFlag',
            label: '부식성유무',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
        ],
      },
      columns4: {
        merge: [
          { index: 0, colName: 'revisionNum' },
          { index: 1, colName: 'revisionNum' },
          { index: 2, colName: 'revisionNum' },
          { index: 3, colName: 'revisionNum' },
          { index: 4, colName: 'mdmChemMaterialId' },
          { index: 8, colName: 'mdmChemMaterialId' },
          { index: 9, colName: 'mdmChemMaterialId' },
          { index: 10, colName: 'mdmChemMaterialId' },
          { index: 11, colName: 'mdmChemMaterialId' },
          { index: 12, colName: 'mdmChemMaterialId' },
          { index: 13, colName: 'mdmChemMaterialId' },
          { index: 14, colName: 'mdmChemMaterialId' },
          { index: 15, colName: 'mdmChemMaterialId' },
          { index: 16, colName: 'mdmChemMaterialId' },
          { index: 17, colName: 'mdmChemMaterialId' },
          { index: 18, colName: 'mdmChemMaterialId' },
        ],
        columns: [
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: '개정번호',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'revisionDt',
            field: 'revisionDt',
            label: '개정일자',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'revisionContent',
            field: 'revisionContent',
            label: '개정사유',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'materialName',
            field: 'materialName',
            label: '화학자재',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'chemNmKr',
            field: 'chemNmKr',
            label: '유해화학물질명',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'casNo',
            field: 'casNo',
            label: '화학물질식별번호',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제사항',
            align: 'center',
            style: 'width:200px',
            type: 'custom',
            sortable: false,
          },
          {
            name: 'serialNo',
            field: 'serialNo',
            label: '고유번호',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'propertiesStateName',
            field: 'propertiesStateName',
            label: '물질상태',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'concentration',
            field: 'concentration',
            label: '농도(%)',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'specificGravity',
            field: 'specificGravity',
            label: '비중',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            label: '폭발한계(%)',
            align: 'center',
            child: [
              {
                name: 'explUpLimit',
                field: 'explUpLimit',
                label: '상한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
              {
                name: 'explLowLimit',
                field: 'explLowLimit',
                label: '하한',
                align: 'center',
                style: 'width:70px',
                sortable: false
              },
            ]
          },
          {
            name: 'toxicType',
            field: 'toxicType',
            label: '독성구분',
            align: 'center',
            style: 'width:300px',
            sortable: false,
          },
          {
            name: 'exposureLevel',
            field: 'exposureLevel',
            label: '위험노출수준',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'acceptableConcentration',
            field: 'acceptableConcentration',
            label: '허용농도값',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'vaporPressure',
            field: 'vaporPressure',
            label: '증기압(20℃)',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'corrosivenessFlag',
            field: 'corrosivenessFlag',
            label: '부식성유무',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
        ],
      },
      grid: {
        data: [],
      },
      editable: true,
      listUrl: '',
      regsUrl: '',
      revisionnoUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.grid.merge = this.columns1.merge;
      this.grid.columns = this.columns1.columns;
      this.listUrl = selectConfig.psi.hsl.hazardmaterials.url;
      this.revisionnoUrl = selectConfig.psi.hsl.hazardmaterials.revisionno;
      this.regsUrl = selectConfig.mdm.mam.chem.regs.url;
      this.getRevision();
      this.getList();
    },
    getRevision() {
      this.$http.url = this.revisionnoUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.revisioinItems = _result.data;
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row, col) {
      this.openChemMaterialPop(row, col.name);
    },
    openChemMaterialPop(row, _name) {
      let tabname = '';
      if (_name == 'materialName') {
        tabname = 'chemPsm';
      } else if (_name == 'chemNmKr') {
        tabname = 'chemMsds';
      }
      this.popupOptions.title = '화학자재 상세';
      this.popupOptions.param = {
        mdmChemMaterialId: row ? row.mdmChemMaterialId : '',
        plantCd: row ? row.plantCd : '',
        tabName: tabname,
      };
      this.popupOptions.target = () => import(`${'@/pages/mdm/mam/chemDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    billCdChange(newValue) {
      if (newValue === null) {
        this.regulatedItems = [];
        this.searchParam.regulatedItemCd = null;
      } else {
        this.regulatedItems = [];
        this.searchParam.regulatedItemCd = null;
        this.$http.url = this.regsUrl;
        this.$http.type = 'GET';
        this.$http.param = {regulationBillCd: newValue};
        this.$http.request((_result) => {
          this.regulatedItems = _result.data;
        },);
      }
    },
    changePlant() {
      this.getRevision();
      this.getList();
      this.saveable = true;
    },
    searchTypeItemChange(_value) {
      this.getRevision();
      if (_value === '1') {
        this.grid.merge = this.columns1.merge;
        this.grid.columns = this.columns1.columns;
        this.searchParam.sysRevision = null;
        this.listUrl = selectConfig.psi.hsl.hazardmaterials.url;
      } else {
        this.grid.merge = this.columns3.merge;
        this.grid.columns = this.columns3.columns;
        this.searchParam.sysRevision = null;
        this.listUrl = selectConfig.psi.hsl.hazardmaterials.url;
      }
      this.saveable = true;
      this.getList();
    },
    revisionChange(_value) {
      if (_value === null) {
        this.saveable = true;
        this.listUrl = selectConfig.psi.hsl.hazardmaterials.url;

        if (this.searchParam.searchTypeItem === '1') {
          this.grid.merge = this.columns1.merge;
          this.grid.columns = this.columns1.columns;
        } else {
          this.grid.merge = this.columns3.merge;
          this.grid.columns = this.columns3.columns;
        }
      } else {
        this.saveable = false;
        this.listUrl = selectConfig.psi.hsl.hazardmaterials.revision;
        this.searchParam.sysRevision = _value;

        if (this.searchParam.searchTypeItem === '1') {
          this.grid.merge = this.columns2.merge;
          this.grid.columns = this.columns2.columns;
        } else {
          this.grid.merge = this.columns4.merge;
          this.grid.columns = this.columns4.columns;
        }
      }
      this.getList();
    },
    openRevision() {
      this.prompt = true;
      
      this.$http.url = selectConfig.com.revision.getversion;
      this.$http.type = 'GET';
      
      if (this.revisioinItems.length > 0) {
        let rInfo = this.revisioinItems[this.revisioinItems.length -1];
        this.$http.param = {revisionNum: rInfo.revisionNum}
        this.$http.request((_result) => {
          this.revisionInfo = {
            plantCd: null,
            sysRevision: rInfo.sysRevision + 1,
            revisionNum: _result.data,
            revisionDt: this.$comm.getToday(),
            revisionContent: '',
            searchTypeItem: this.searchParam.searchTypeItem,
            regUserId: this.$store.getters.user.userId,
          }
        });
      } else {
        this.$http.param = {revisionNum: ''}
        this.$http.request((_result) => {
          this.revisionInfo = {
            plantCd: null,
            sysRevision: '1',
            revisionNum: _result.data,
            revisionDt: this.$comm.getToday(),
            revisionContent: '',
            searchTypeItem: this.searchParam.searchTypeItem,
            regUserId: this.$store.getters.user.userId,
          }
        });
      }
    },
    cancelRevision() {
      this.prompt = false;
      this.revisionInfo = {
        plantCd: null,
        sysRevision: '',
        revisionNum: '',
        revisionDt: '',
        revisionContent: '',
        searchTypeItem: '1',
      }
    },
    saveRevision() {
      if(this.revisionInfo.sysRevision != '') {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '현재 유해위험목록을 개정하시겠습니까?',
          type: 'info',
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = selectConfig.psi.hsl.hazardmaterials.revision;
            this.$http.type = 'POST';
            this.$http.param = this.revisionInfo;
            this.$http.request(() => {
              window.getApp.$emit('ALERT', {
                title: '안내', // 안내
                message: '개정번호가 추가되었습니다.', 
                type: 'success', // success / info / warning / error
              });
              this.getRevision();
              this.prompt = false;
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>